import { useEffect, useState } from "react";
import { useGetUserInfo } from "features/users/hooks/useGetUserInfo";
import { i18nextInitializationPromise } from "ui/locale";
import { useGetOrganizationInfo } from "features/organization/hooks/useGetOrganizationInfo";
import { authSessionService } from "features/auth/services/authSessionService";

export function useLoad(): boolean {
    const [loading, setLoading] = useState(true);

    const { refetch: prefetchUserInfo } = useGetUserInfo({ enabled: false });
    const { refetch: prefetchOrganizationInfo } = useGetOrganizationInfo({ enabled: false });

    useEffect(() => {
        (async function () {
            await i18nextInitializationPromise;

            await authSessionService.verifySession();

            if (authSessionService.userIsLoggedIn()) {
                await prefetchUserInfo();
                await prefetchOrganizationInfo();
            }

            setLoading(false);
        })();
    }, []);

    return loading;
}
